import React, { useEffect, useState } from 'react';
import {
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    Typography,
    Box,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PendingIcon from '@mui/icons-material/Pending';
import InfoIcon from '@mui/icons-material/Info';
import CancelIcon from '@mui/icons-material/Cancel';
import InquiryResultSkeleton from './inquiryResultSkeleton';
import './inquiryResult.css';
import CustomisedButton from '../../../../components/button/button';
import { changeRouteType, getpervInnerState } from '../../../../redux/handleBackBtn/handleBackBtnSlice';
import { useDispatch } from 'react-redux';
import { v4 as uuid } from 'uuid';
import { IInquiry } from '../IInquriry';
import { useMutation, useQueryClient } from 'react-query';
import { getrequiredInquiryList, TotalInquiry } from '../../../../services/inquiry.service';
import { TotalInquiryRequest, IInquiryResponse, IInquiryResult } from '../../../../models/inquiry.model';
import { useAppBar } from '../../../../components/appBar/appBarContext';
import { ApiResultModel } from '../../../../models/common.model';
import { INQUIRY_REQUIRED_OTP, INQUIRY_RESULT } from '../../../../config/cacheKey';

interface ListItemData {
    label: string;
    subtext: string;
    icon: React.ReactElement;
}


const InquiryResult = ({ referenceKey, setInnerState, setStep }: IInquiry) => {
    const [loading, setLoading] = useState(true);
    const [state, setState] = useState<string>();
    const [data, setData] = useState<IInquiryResult[]>();
    const { setHeader } = useAppBar();
    const dispatch = useDispatch();
    const randomKeyForDispatch = Math.random();
    const request = {} as TotalInquiryRequest;
    request.referenceKey = referenceKey!;
    useEffect(() => {
        setTimeout(() => setLoading(false), 2000);
        setHeader('نتیجه استعلام‌ها', 'inquiry')
        dispatch(changeRouteType({ routeType: 'infoDetail' }));
        getrequiredInquiryListMutation(request);

    }, []);
    // const time = 2 * 1000 * 60;
    // setTimeout(() => { getrequiredInquiryListMutation(request); }, time);
    const handleContinue = () => {
        if (state === 'Approved') {
            setStep(uuid());
        } else if (state === 'WaitForOtp' || state === 'ApiCallError') {
            InquiryValidationOTPMutation(request);
        }
        else {
            // setInnerState!('fee');
        }
        // getrequiredInquiryListMutation(request);
    }
    const queryClient = useQueryClient();
    const { mutateAsync: InquiryValidationOTPMutation } = useMutation(TotalInquiry, {
        onSuccess: (data: ApiResultModel<IInquiryResponse>) => {
            if (data.isSuccess) {
                if (data.data) {
                    if (data.data.requiredOtpValidation) {
                        setInnerState!('otp');
                        queryClient.setQueryData(INQUIRY_REQUIRED_OTP, data.data.requiredOtpValidation);

                    }


                }
            }


        },
        onError: () => { },
    });
    const { mutateAsync: getrequiredInquiryListMutation, isLoading } = useMutation(getrequiredInquiryList, {
        onSuccess: (data: IInquiryResponse) => {
            if (data) {
                if (data.inquiries.length > 0) {
                    setData(data.inquiries);
                    setState(data.state);
                    if (data.state === 'Approved') {
                        dispatch(changeRouteType({ routeType: 'infoDetail' }));
                    } else {
                        dispatch(changeRouteType({ routeType: 'child' }));

                        dispatch(getpervInnerState({ prevInnerState: `inquiry ${randomKeyForDispatch}` }));
                    }
                }
                else {
                    // setStep(uuid);
                }

            }
        },
        onError: () => { },
    });

    if (isLoading) {
        return <InquiryResultSkeleton />;
    }
    return (
        <div className="container-height-drawer">
            <Box className='content-container'>
                <List className='drawer-content'>
                    {data?.map((item, index) => (
                        <ListItem
                            key={index}
                            sx={{
                                padding: '4px !important',
                                alignItems: 'flex-start',
                                position: 'relative',
                                paddingY: '16px',
                                '&:before': {
                                    content: '""',
                                    position: 'absolute',
                                    right: '17px',
                                    top: '20%',
                                    bottom:
                                        index === data.length - 1
                                            ? 'auto'
                                            : '-5%',
                                    width: '1px',
                                    backgroundColor:
                                        index === data.length - 1
                                            ? 'transparent'
                                            : '#ccc',
                                },
                            }}
                        >
                            <ListItemIcon sx={{ minWidth: '40px', zIndex: '5' }}>
                                {item.state == 'WaitForOtp' || item.state == 'InProgress ' ? <PendingIcon className="primaryColorLight-300 iconSize" /> : item.state == 'Approved' ? <CheckCircleIcon className="text-[#BBA57A] bg-[var(--bg-color)] rounded-full iconSize" /> : item.state == 'Rejected ' ? <InfoIcon className="primaryErrorColorLight iconSize" /> : <CancelIcon className="primaryErrorColorLight iconSize" />}
                            </ListItemIcon>
                            <ListItemText
                                sx={{ marginTop: '2px' }}
                                primary={
                                    <Typography
                                        variant="body1"
                                        textAlign="right"
                                        fontWeight="bold"
                                        className='text-[var(--primary-text-color)]'
                                    >
                                        {item.inquiryTypeTitle} &nbsp;
                                    </Typography>
                                }
                                secondary={
                                    <Typography
                                        variant="body2"
                                        className="primaryColorLight-100"
                                        textAlign="right"
                                    >
                                        {item.inquiryInfo}&nbsp;
                                    </Typography>
                                }
                            />
                        </ListItem>
                    ))}
                </List>
                <Box className="py-5">
                    <CustomisedButton
                        title={state === 'Approved' || state === 'WaitForOtp' ? '  ادامه' : 'استعلام مجدد'}
                        disable={state === 'InProgress'}
                        onClick={handleContinue}
                        type="button"
                    />
                </Box>
            </Box>
        </div>
    );
};

export default InquiryResult;
